import axios from 'axios';
import { makeAutoObservable } from 'mobx';
import { IS_DEVELOPMENT, SKD_FRONTEND_VERSION } from 'src/libs/env';

class ObservableFrontendVersion {
	frontendVersion: string = null;

	constructor() {
		makeAutoObservable(this);
	}

	async fetchVersion() {
		if (IS_DEVELOPMENT) {
			return;
		}
		try {
			const response = await axios.get('/frontend_version.txt');
			this.frontendVersion = response.data.trim();
		} catch (error) {
			console.error('frontend version check failed:', error);
		}
	}

	isOutdated() {
		if (!this.frontendVersion) {
			return false;
		}
		return this.frontendVersion !== SKD_FRONTEND_VERSION;
	}
}

const FrontendVersionStore = new ObservableFrontendVersion();
export default FrontendVersionStore;
